import { render, staticRenderFns } from "./IconZbjb.vue?vue&type=template&id=7851cd1c"
import script from "./IconZbjb.vue?vue&type=script&lang=js"
export * from "./IconZbjb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports